import type { DisplayMedia } from "@/lib/types/media";
import { getResizedImageUrl } from "@/lib/imageUrl";

interface GalleryItemBadgesProps {
  item: DisplayMedia;
}

export function GalleryItemBadges({ item }: GalleryItemBadgesProps) {
  return (
    <>
      {/* Resolution badge — top-right */}
      {item.resolution && (
        <div className="absolute top-2 end-2 px-2 py-0.5 rounded-full bg-brand/80 backdrop-blur-sm text-white text-[10px] font-bold">
          {item.resolution.toUpperCase()}
        </div>
      )}

      {/* Reference image thumbnail(s) — bottom-left */}
      {item.referenceImageUrls[0] && (
        <div className="absolute bottom-2 start-2 w-8 h-8 rounded-lg overflow-hidden border border-white/30 bg-black/40 backdrop-blur-sm">
          <img
            src={getResizedImageUrl(item.referenceImageUrls[0], 64)}
            loading="lazy"
            className="w-full h-full object-cover"
            alt=""
          />
        </div>
      )}
    </>
  );
}
